import { defineComponent as g, resolveComponent as y, openBlock as p, createElementBlock as k, toDisplayString as v, createBlock as b, withCtx as m, renderSlot as h } from "vue";
import { InputComp as M } from "./InputComp.js";
import { i as f } from "./isNil.6f60d6a4.js";
import { V as T } from "./WrapperComp.204dcf4e.js";
import { u as S } from "./uniqueId.f48d78c2.js";
import { _ as V } from "./_plugin-vue_export-helper.dad06003.js";
const c = /[-!$%^&*()_+|~=`{}[\]:";'<>?,./\\ ]/;
function A(e) {
  return e ? c.test(e) : !1;
}
const u = {
  "#": {
    test: (e) => /[0-9]/.test(e),
    convert: (e) => e
  },
  A: {
    test: (e) => /[A-Z]/i.test(e),
    convert: (e) => e.toUpperCase()
  },
  a: {
    test: (e) => /[a-z]/i.test(e),
    convert: (e) => e.toLowerCase()
  },
  N: {
    test: (e) => /[0-9A-Z]/i.test(e),
    convert: (e) => e.toUpperCase()
  },
  n: {
    test: (e) => /[0-9a-z]/i.test(e),
    convert: (e) => e.toLowerCase()
  },
  X: {
    test: A,
    convert: (e) => e
  }
}, d = (e) => u[e] !== void 0, B = (e, t) => {
  const a = u[e];
  return f(a) ? t : a.convert(t);
}, C = (e, t) => t == null || !d(e) ? !1 : u[e].test(t);
function n(e, t, a) {
  if (e == null)
    return "";
  if (e = String(e), !t.length || !e.length)
    return e;
  Array.isArray(t) || (t = t.split(""));
  let r = 0, i = 0, o = "";
  for (; i < t.length; ) {
    const s = t[i], l = e[r];
    if (f(l))
      return o;
    if (!d(s) && l === s)
      o += s, r++;
    else if (!d(s) && !a)
      o += s;
    else if (C(s, l))
      o += B(s, l), r++;
    else
      return o;
    i++;
  }
  return o;
}
function $(e) {
  return e && String(e).replace(new RegExp(c.source, "g"), "");
}
const U = g({
  mixins: [T],
  components: {
    InputComp: M
  },
  events: {
    "update:modelValue": {
      type: String
    },
    "update:errorMessages": {
      type: Array
    }
  },
  props: {
    id: {
      type: String,
      required: !1,
      default: () => S("maskComp")
    },
    modelValue: {
      type: String,
      default: null
    },
    mask: {
      type: String,
      default: null
    },
    validationRules: {
      type: Array,
      default: () => []
    },
    errorMessages: {
      type: Array,
      default: () => [],
      Note: 'This is the secondary v-model:errorMessages="" of the component'
    },
    readonly: Boolean,
    placeholder: String,
    label: String,
    supportingText: String,
    /**
     * Used for disabling error or info messages from being seen or validation from running
     */
    disableMessages: Boolean,
    /**
     * Used for determining when to run the validation rules on input
     */
    validateOn: {
      type: String,
      default: "blur"
    },
    legacy: Boolean,
    width: String,
    disabled: Boolean,
    labelAbove: Boolean,
    autocomplete: String
  },
  data() {
    return {
      forceMaskToUpdateKey: 0
    };
  },
  computed: {
    maskedText() {
      return this.forceMaskToUpdateKey, n(this.modelValue, this.mask, !1);
    },
    maskedValue: {
      get() {
        return this.mask ? this.maskedText : this.modelValue;
      },
      set(e) {
        var t;
        if (!this.mask)
          this.$emit("update:modelValue", e);
        else if ((e == null ? void 0 : e.length) <= ((t = this.mask) == null ? void 0 : t.length)) {
          const a = $(n(e, this.mask, !1));
          this.modelValue === a && this.forceMaskToUpdateKey++, this.$emit("update:modelValue", a);
        } else
          this.forceMaskToUpdateKey++;
      }
    },
    text() {
      return this.readonly && this.mask ? this.maskedText : this.readonly && !this.mask ? this.modelValue : null;
    },
    maskedPlaceholder() {
      return this.mask ? n(this.placeholder || "", this.mask, !1) : "";
    }
  },
  methods: {
    async handleBlur() {
      this.validateInputOnBlur();
    },
    validate() {
      const e = this.runValidationMethod(this.modelValue);
      return this.$emit("update:errorMessages", e), e.filter((t) => t.id === this.id);
    }
  }
});
const w = { key: 0 };
function I(e, t, a, r, i, o) {
  const s = y("input-comp");
  return e.readonly ? (p(), k("span", w, v(e.text), 1)) : (p(), b(s, {
    key: 1,
    id: e.id,
    type: "text",
    modelValue: e.maskedValue,
    "onUpdate:modelValue": t[0] || (t[0] = (l) => e.maskedValue = l),
    onBlur: e.handleBlur,
    placeholder: e.maskedPlaceholder,
    label: e.label,
    supportingText: e.supportingText,
    validationRules: e.validationRules,
    errorMessages: e.errorMessages,
    disableMessages: e.disableMessages,
    validateOn: e.validateOn,
    legacy: e.legacy,
    width: e.width,
    disabled: e.disabled,
    labelAbove: e.labelAbove,
    autocomplete: e.autocomplete
  }, {
    prepend: m(() => [
      h(e.$slots, "prepend", {}, void 0, !0)
    ]),
    append: m(() => [
      h(e.$slots, "append", {}, void 0, !0)
    ]),
    _: 3
  }, 8, ["id", "modelValue", "onBlur", "placeholder", "label", "supportingText", "validationRules", "errorMessages", "disableMessages", "validateOn", "legacy", "width", "disabled", "labelAbove", "autocomplete"]));
}
const N = /* @__PURE__ */ V(U, [["render", I], ["__scopeId", "data-v-bd7bcd9a"]]);
export {
  N as MaskComp
};
//# sourceMappingURL=MaskComp.js.map
